import React, { useContext, useRef, useEffect } from "react";
import { useQuery } from "react-query";
import { getAxiosTokenInstance } from "../../utils/axiosInstance";
import { FirebaseContext } from "../../context/FirebaseContext";
import { List } from "antd";

// Fetch dropdown data
export const getFieldDropDowns = (data) => async () => {
  const instance = await getAxiosTokenInstance();
  try {
    const resp = await instance.get("/college/action/getUserNames", {
      params: { ...data },
    });
    if (resp.data.statusCode === 400) {
      throw new Error(resp.data.message || "API Error");
    } else {
      return resp?.data?.list[0].data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message || "API Error");
  }
};

function SearchableUserInput({
  primoryKey,
  secondaryKey,
  tertiaryKey,
  collection,
  stateData,
  setStateData,
  titleData
}) {
  const { collegeId } = useContext(FirebaseContext);
  const [showList, setShowList] = React.useState(false);
  const nameOfAuthor = useRef(null);

  // Close dropdown on outside click
  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowList(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };

  const { data: nameOfAuthorDrop = [] } = useQuery(
    ["dataDataData", stateData[primoryKey], collection, primoryKey, secondaryKey, tertiaryKey],
    getFieldDropDowns({ collegeId, collection, primoryKey, secondaryKey, tertiaryKey, search: stateData[primoryKey] })
  );
  
  useOutsideAlerter(nameOfAuthor);

  return (
    <div className="p-2">
      <div className="my-2">
        <div className="relative group">
          <input
            type="text"
            onChange={(e) => setStateData({ ...stateData, [primoryKey]: e.target.value })}
            onFocus={() => setShowList(true)}
            value={stateData[primoryKey]}
            className="w-full p-2 text-lg  dark:text-white dark:bg-[#202020f5] border-2 border-gray-300 focus:outline-none focus:ring-2 focus:ring-black  dark:border-white rounded-md"
          />
          <label className="absolute  text-sm font-semibold transition-all ease-in-out left-2  dark:text-white ">
            {titleData}
          </label>
        </div>

        <div ref={nameOfAuthor}>
          {showList && stateData[primoryKey] && nameOfAuthorDrop.length ? (
            <List
              size="small"
              style={{ margin: 0, padding: 0 }}
              dataSource={nameOfAuthorDrop}
              renderItem={(item) => (
                <List.Item>
                  <div
                    style={{ cursor: "pointer", width: "100%", height: 20 }}
                    className=" dark:text-white hover:bg-white dark:hover:bg-black  px-2 py-1"
                    onClick={() =>
                      setStateData({
                        ...stateData,
                        collegeId: item.collegeId[0],
                        [primoryKey]: item[secondaryKey],
                        _id: item._id,
                        data: [],
                      })
                    }
                  >
                    {item[primoryKey] + " " + item[secondaryKey]}
                  </div>
                </List.Item>
              )}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default SearchableUserInput;
